import styled from 'styled-components';

import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    TextField,
    Pagination,
    Box,
    Typography,
    Select,
    MenuItem
} from '@mui/material';

// Styled Components following project conventions
export const TableContainerStyled = styled(TableContainer)`
    border: 1px solid #cdd2d9;
    border-radius: 8px;
    background-color: #ffffff;
    overflow-x: auto;
`;

export const TableStyled = styled(Table)`
    min-width: 800px;

    @media (max-width: 1200px) {
        min-width: 600px;
    }
`;

export const HeaderCell = styled(TableCell)`
    && {
        background-color: #ebefed;
        color: #194727;
        font-weight: 600;
        font-size: 14px;
        padding: 12px 16px;
        border-bottom: 2px solid #cdd2d9;
        white-space: nowrap;
    }
`;

export const BodyCell = styled(TableCell)`
    && {
        padding: 8px 16px;
        font-size: 14px;
        color: #333333;
        border-bottom: 1px solid #e0e0e0;
    }
`;

export const NumberInput = styled(TextField)`
    && {
        .MuiInputBase-root {
            height: 36px;
        }
        .MuiInputBase-input {
            text-align: center;
            padding: 8px;
            font-size: 14px;
        }
    }
`;

export const ActionButton = styled(IconButton)`
    && {
        border-radius: 8px;
        padding: 4px;
        color: #3a6647;
        background-color: #ebefed;
        &:hover {
            background-color: rgba(58, 102, 71, 0.08);
        }
        &.Mui-disabled {
            color: #ccc;
        }
    }
`;

export const PeriodButton = styled.button`
    padding: 6px 16px;
    border-radius: 4px;
    border: none;
    font-size: 14px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s ease;
    background-color: #e0e0e0;
    color: #333333;

    &:hover {
        background-color: #535353;
        color: #ffffff;
    }

    &.active {
        background-color: #7c8187;
        color: #ffffff;
    }

    &:disabled {
        color: #999999;
        cursor: not-allowed;
    }
`;

export const PaginationWrapper = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-top: 1px solid #e0e0e0;
    flex-wrap: wrap;
    gap: 16px;

    @media (max-width: 768px) {
        justify-content: center;
    }
`;

export const PaginationInfo = styled(Typography)`
    color: #666666;
    font-size: 14px;
`;

export const PerPageSelect = styled(Select)`
    && {
        height: 36px;
        font-size: 14px;
        min-width: 80px;
    }
`;

export const TableHeaderActions = styled(Box)`
    display: flex;
    align-items: center;
    gap: 12px;

    @media (max-width: 768px) {
        flex-wrap: wrap;
    }
`;
